import { useMemo } from 'react';
import {
	filterKeys,
	getEntityById,
	nullSafeGetOrElse,
	parseFilterValueToAdvancedFilters,
} from '../../utils/DataAccessUtils';
import { SORTING_PROPS } from '../../utils/DataConstants';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';

function WorkOrderFiltersWrapper({ children, currentUser, location, view, defaultView }) {
	const selectedView = view || defaultView;
	const defaultFilters = useMemo(() => {
		if (view || (location && !Boolean(location.search))) {
			const defaultFilterView = nullSafeGetOrElse('filterValue', selectedView, {});
			return filterKeys(
				parseFilterValueToAdvancedFilters(defaultFilterView),
				[...SORTING_PROPS, getWorkOrderArchivalKey(currentUser)],
				false
			);
		}
	}, [selectedView, location, currentUser, view]);

	return children(defaultFilters); // Pass filters to child as render prop
}

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	defaultView: state.session.defaultView,
});

const mapDispatchToProps = (dispatch, ownProps) => ({});
const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(WorkOrderFiltersWrapper)
);
export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(Form.create()(ComponentWithoutUserType));
